import { useEffect, useState } from 'react';
import { getBaseApiPath } from '@/app/common/api/config';

async function probeUrl(url: string, timeoutMs: number): Promise<boolean> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    await fetch(url, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timer);
  }
}

/** True if the public network is reachable; `null` while checking. */
export async function checkInternetReachable(timeoutMs = 3500): Promise<boolean> {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return false;
  }

  const urls = [
    `${getBaseApiPath()}/keyword_related/v1/massive/healthcheck?`,
  ];

  for (const url of urls) {
    if (await probeUrl(url, timeoutMs)) return true;
  }

  return false;
}

export function useInternetReachable(enabled: boolean): boolean | null {
  const [reachable, setReachable] = useState<boolean | null>(null);

  useEffect(() => {
    if (!enabled) {
      setReachable(null);
      return;
    }

    let cancelled = false;
    setReachable(null);

    checkInternetReachable().then(result => {
      if (!cancelled) setReachable(result);
    });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return reachable;
}
